import Header from "./Header"
import Footer from "./Footer"
import { Outlet } from "react-router-dom"
import ScrollToTop from "../ScrollToTop"

const Layout = () => {
    return (
        <div>
            <ScrollToTop />
            <Header />
            <Outlet />
            <Footer />
        </div>
    )
}

export default Layout